import { TipoEndosso } from "../TipoEndosso";
import { EnumValue } from "./enum-value";

export const TipoEndossoEnum = {
    mudanca_endereco: 'MUDANCA_ENDERECO',
    novo_local_estacionamento: 'NOVO_LOCAL_ESTACIONAMENTO',
    novo_condutor: 'NOVO_CONDUTOR',
    coberturas: 'COBERTURAS',
    mudanca_cep_pernoite: 'MUDANCA_CEP_PERNOITE',
    substituicao_veiculo: 'SUBSTITUICAO_VEICULO',
    transferencia_seguro: 'TRANSFERENCIA_SEGURO',
    alteracao_combustivel: 'ALTERACAO_COMBUSTIVEL'
}

export const TipoEndossoValues: EnumValue[] = [
    {
        codigo: TipoEndossoEnum.mudanca_endereco,
        descricao: 'Mudança de endereço'
    },
    {
        codigo: TipoEndossoEnum.novo_local_estacionamento,
        descricao: 'Novo local de circulação ou estacionamento do veículo'
    },
    {
        codigo: TipoEndossoEnum.novo_condutor,
        descricao: 'Cadastro de novos condutores do veículo'
    },
    {
        codigo: TipoEndossoEnum.coberturas,
        descricao: 'Inclusão ou exclusão de coberturas'
    },
    {
        codigo: TipoEndossoEnum.mudanca_cep_pernoite,
        descricao: 'Mudança de CEP de pernoite'
    },
    {
        codigo: TipoEndossoEnum.substituicao_veiculo,
        descricao: 'Substituição do veículo'
    },
    {
        codigo: TipoEndossoEnum.transferencia_seguro,
        descricao: 'Transferência de seguro'
    },
    {
        codigo: TipoEndossoEnum.alteracao_combustivel,
        descricao: 'Alteração do combustível'
    },
]

export const getTipoEndossoLabel = (tipo: TipoEndosso): string => {
    const match = TipoEndossoValues.find(
      value => value.codigo === tipo
    );
    return match ? match.descricao : '';
  };

